import { getStorage } from "./keyvaluestorage.js";

const svgIconSelector = 'svg.c-icon';
const fileInfoSelector = 'span.c-file-info';
const svgFile = '/images/svg.svg';

function getSvgUrl(el) {
	const attributed = el?.getAttribute('data-svg-url');
	if (attributed) {
		return attributed;
	}
	const scriptUrl = getStorage().getStoredValue('scriptUrl') ?? '';
	if (scriptUrl){
		const path = new URL(scriptUrl)?.pathname;
		const endOfResourcePath = path?.indexOf('/js/') ?? -1;
		if (endOfResourcePath > -1) {
			const relativePath = path.substring(0,endOfResourcePath);
			return `${relativePath}${svgFile}`
		}
	}
	return false;
}

function getYesterday(el) { return el?.getAttribute('data-yesterday'); }

function renderIconTemplate(el, iconName, svgUrl) {
	if (!el || !iconName) {
		return false;
	}
	if (!el.querySelector(svgIconSelector) && svgUrl) {
		return `<svg class="c-icon c-icon--${iconName}"><use xlink:href="${svgUrl}#${iconName}" /></svg>`;
	} else {
		return false;
	}
}

function renderSizeTemplate(el, type, size) {
	if (!el) {
		return false;
	}
	if (!el.querySelector(fileInfoSelector) && type && size) {
		return `<span class="c-file-info">(${type} - ${size})</span>`;
	} else {
		return false;
	}
}
/*
 * Add a leading 0 to numbers < max
 */

function _pad(n, max = 10) {
	return (n < max) ? ('0' + n) : n;
}

/*
 * Replaces the string in the data-yesterday attribute
 * with the date of yesterday in the format DD-MM-YYYY
 */

export function replaceYesterday(node) {
	// only preceed if the attribute exists and contains something other than spaces
	let yesterday = getYesterday(node);
	if (yesterday && !!yesterday.replace(/\s/g, '').length) {
		const d = new Date();
		d.setDate(d.getDate() - 1); // set date to yesterday
		const yesterdate = `${_pad(d.getDate())}-${_pad(d.getMonth() + 1)}-${d.getFullYear()}`;
		const html = node.innerHTML;
		const regex = new RegExp(yesterday, 'gi');
		const replacedHtml = html.replace(regex, yesterdate);

		// Only replace the html when something was replaced
		if (html !== replacedHtml) {
			node.innerHTML = replacedHtml;
		}
	}
}


export function enhanceLinks(node) {
	const _links = [...node.querySelectorAll('a:not(.c-link):not(.c-button):not([id^=term]):not([data-role])')];

	_links.forEach( link => {
		if (!(link.querySelector('.c-link__text'))) {
			const content = link.innerHTML;
			link.innerHTML = `<span class="c-link__text">${content}</span>`;
		}
		link.classList.add('c-link');
	});
}

export function enhanceExternals(node) {
	const _links = [...node.querySelectorAll('a[rel="external"]')];
	const svgUrl = getSvgUrl(node);

	_links.forEach(link => {
		let svgPart = renderIconTemplate(link, 'external-link', svgUrl);

		if (svgPart){
			link.insertAdjacentHTML('beforeend', svgPart);
		}
	});
}

export function enhanceType(node) {
	const _links = [...node.querySelectorAll('[data-type]')];
	const svgUrl = getSvgUrl(node);

	_links.forEach(link => {
		let type = link.getAttribute('data-type');
		let svgPart = renderIconTemplate(link, type, svgUrl);

		if (svgPart) {
			link.insertAdjacentHTML('afterbegin', svgPart);
		}
	});
}

export function enhanceSize(node) {
	const _links = [...node.querySelectorAll('[data-size]')];

	_links.forEach(link => {
		let type = link.getAttribute('data-type');
		let size = link.getAttribute('data-size');
		let sizePart = renderSizeTemplate(link, type, size);
		if (sizePart) {
			link.insertAdjacentHTML('beforeend', sizePart);
		}
	});
}

export function runLinkEnhancements(node) {
	enhanceLinks(node);
	enhanceSize(node);
	enhanceType(node);
	enhanceExternals(node);
	return node;
}
